import { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  Container,
  HeaderProcess,
  InfoNavbar,
  ModalMedicalCoverage,
  Plan
} from '../components';
import { useView } from '../hooks';
import { navigate } from '../store/Commons';
import { IPlan, selectedPlan } from '../store/Quote';
import { env } from '../env';

interface IMatrixProps {
  documentId: string;
  charges: number;
  email: string;
  plansWithConsultation: any[];
  plansWithoutConsultation: any[];
  selectPlan: (payload: IPlan) => void;
  back: (p: string) => void;
}

export function Matrix(props: IMatrixProps) {
  const {
    back,
    charges,
    plansWithConsultation,
    plansWithoutConsultation,
    selectPlan,
  } = props;
  const { grid } = useView();
  const goBack = () => back('/');
  const plans = plansWithConsultation.concat(plansWithoutConsultation);

  const [currentPdf, setCurrentPdf] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [currentCoverage, setCurrentCoverage] = useState(0);
  const [currentTopeAnual, setCurrentTopeAnual] = useState(0);
  const [currentConsultation, setCurrentConsultation] = useState(false);
  const [currentAmbulatory, setCurrentAmbulatory] = useState(false);
  const [currentAmbulatoryFull, setCurrentAmbulatoryFull] = useState(false);
  const [currentHospitable, setCurrentHospitable] = useState(false);
  const [currentMaternity, setCurrentMaternity] = useState(false);
  const [currentKinesiologyHealth, setCurrentKinesiologyHealth] = useState(false);
  const togglePdf = (pdf: string) => (_: any) => setCurrentPdf(pdf);
  const toggleModal = (state: boolean) => (_: any) => setOpenModal(state);
  const toggleCoverage = (coverage: number) => (_: any) => setCurrentCoverage(coverage);
  const toggleTopeAnual = (topeAnual: number) => (_: any) => setCurrentTopeAnual(topeAnual);
  const toggleConsultation = (consultation: boolean) => (_: any) => setCurrentConsultation(consultation);
  const toggleAmbulatory = (ambulatory: boolean) => (_: any) => setCurrentAmbulatory(ambulatory);
  const toggleAmbulatoryFull = (ambulatoryFull: boolean) => (_: any) => setCurrentAmbulatoryFull(ambulatoryFull);
  const toggleMaternity = (maternity: boolean) => (_: any) => setCurrentMaternity(maternity);
  const toggleHospitable = (hospitable: boolean) => (_: any) => setCurrentHospitable(hospitable);
  const toggleKinesiologyHealth = (kinesiologyHealth: boolean) => (_: any) => setCurrentKinesiologyHealth(kinesiologyHealth);
  
  useEffect(() => {
  if (env.REACT_APP_ENVIRONMENT === 'production'|| env.REACT_APP_GTM_QA_ACTIVE === 'true') {
    ReactGA.send({
      user_id: sessionStorage.getItem('userId'),
      hitType: 'pageview',
      location: 'salud.segurosfalabella.com/salud/cotizacion',
      title: 'Seguro Salud Complementario',
    });

    // Funnel step viewed
    ReactGA.event("funnel_step_viewed", {
      'funnel_name': 'contratacion-seguro',
      'product_name': 'web-salud-complementario',
      'funnel_step_name': 'paso-cotizacion'
    });
  }
}, []);

  return (
    <>
      <Container>
        <HeaderProcess stage={1}/>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6 mt-24">
              {plans.length > 0 ? (
                <div className="new-title-matrix">
                  <h3 className="mb0 px-24">
                    Las mejores opciones para tí!
                  </h3>
                  <p className="px-14">Puedes elegir atenderte en el centro médico que quieras con cualquiera de nuestros planes</p>
                  <p className="mt-14 px-14">
                    <b>{ plans.length } Resultados</b> de búsqueda para:<br/>
                    <span>
                      Titular { 
                        charges ? " + " + 
                        (charges === 3 ? "3 o más" : charges) + " " + 
                        (charges > 1 ? "asegurados adicionales" : "asegurado adicional") : " sin carga"
                      }
                    </span>
                  </p>
                </div>
              ) : (
                <div>
                  <h2 className="text-center mt60 mb50">
                    Lamentablemente no puedes avanzar en la contratación, es
                    posible que ya cuentes con este producto o no cumplas con la
                    edad de contratación
                  </h2>
                  <h3 className="text-center">
                    Para cualquier consulta, no dudes en llamar al Centro de
                    Atención al Cliente de Seguros Falabella Corredores, al
                    teléfono 600 390 1000 ó al 02 2390 6570
                  </h3>
                </div>
              )}
              {plans.length > 0 ? (
                <div className="row mt-24 mx-0">
                  <div className="d-flex flex-xl-wrap row-plan-slides">
                    {plans.map((plan, index) => (
                      <Plan
                        {...plan}
                        key={plan.properties.id}
                        planNumber={index}
                        selectPlan={selectPlan}
                        grid={grid}
                        charges={charges}
                        toggle={toggleModal}
                        togglePdf={togglePdf}
                        toggleTope={toggleTopeAnual}
                        toggleCoverage={toggleCoverage}
                        toggleConsultation={toggleConsultation}
                        toggleAmbulatory={toggleAmbulatory}
                        toggleAmbulatoryFull={toggleAmbulatoryFull}
                        toggleMaternity={toggleMaternity}
                        toggleHospitable={toggleHospitable}
                        toggleKinesiologyHealth={toggleKinesiologyHealth}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                <div className="col-12 col-sm-8 col-md-5 mx-auto">
                  <button
                    className="btn primary quote-fail-retry"
                    type="button"
                    onClick={goBack}
                  >
                    Volver a cotizar
                  </button>
                </div>
              )}
            </div>
            
          </div>
        </div>
        <InfoNavbar/>
        <div className="row justify-content-center padding-1">
          <div className="text-center d-flex col-10 col-sm-6 col-md-5 col-lg-6 padding-auto-custom justify-content-center align-content-center align-items-center mx-auto mb5 mt5 px-18">
            <p>Si necesitas más información llámanos al <a href="tel:800380800">800 380 800</a></p>
          </div>
        </div>
      </Container>
      <ModalMedicalCoverage 
      pdf={currentPdf} 
      open={openModal} 
      consultation={currentConsultation} 
      topeAnual={currentTopeAnual} 
      toggle={toggleModal} 
      coverage={currentCoverage} 
      ambulatory={currentAmbulatory} 
      ambulatoryFull={currentAmbulatoryFull}
      hospitable={currentHospitable} 
      maternity={currentMaternity}
      kinesiologyHealth={currentKinesiologyHealth}/>
    </>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: {
      data: { documentId, email, charges },
      quote: { plansWithConsultation, plansWithoutConsultation },
    },
  } = state;

  return {
    documentId,
    charges: Number(charges),
    email,
    plansWithConsultation,
    plansWithoutConsultation,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  back: (payload: string) => dispatch(navigate(payload)),
  selectPlan: (payload: IPlan) => dispatch(selectedPlan(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Matrix);
